import { PsMessageStates } from '../../PsMessageStates';

export class MessageSearchRequest {

    _page; // number
    _term; // string
    _limit; // number
    _state; // MessageStates

    constructor(limit = 100) {
        this._page = 1;
        this._term = '';
        this._limit = limit;
        this._state = PsMessageStates.ALL;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setState(state) {
        this._state = state;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                limit: this._limit,
                active: this._state === PsMessageStates.ALL ? undefined : this._state === PsMessageStates.OPENED,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/shared/message-search/MessageSearchRequest.js